import i18n from "config/i18next";

i18n.addResources("es", "filterTransactions", {
  pickerIdLabel: "Id del picker",
  pickerIdPlaceholder: "Ingresá el n° de picker",
  tripCodeLabel: "Código de viaje",
  tripCodePlaceholder: "Ingresá el código",
  orderNumberLabel: "Número de orden",
  orderNumberPlaceholder: "Ingresá el n° de orden",
  dateLabel: "Fecha",
  datePlaceholder: "Seleccioná la fecha",
  stateLabel: "Estados",
  statePlaceholder: "Seleccioná el estado",
  regionsLabel: "Regiones",
  regionsPlaceholder: "Seleccioná la región",
  workzonesLabel: "Zonas de trabajo",
  workzonesPlaceholder: "Seleccioná la zona",
  originsLabel: "Punto de origen",
  originsPlaceholder: "Seleccioná el punto de origen",
  skuLabel: "SKU",
  skuPlaceholder: "Ej: 134,MEL,WER41",
  transactionCodeLabel: "Código de transacción",
  transactionCodePlaceholder: "Ingresá el código",
  codeTransactionError: "El código ingresado es erróneo",
  tripCodeError: "El código ingresado es erróneo",
  skuError: "No debe superar los 10 SKUs",
  created: "Creación",
  notAssigned: "Sin asignar",
  pendingAssignment: "Pendiente de asignación",
  assigned: "Asignado",
  inPickup: "En retiro",
  retired: "Retirado",
  inPickupPoint: "En lugar de retiro",
  inDelivery: "En entrega",
  inDeliveryPoint: "En lugar de entrega",
  delivered: "Entregado",
  inReturnToSender: "En devolución",
  returnedToSender: "Devuelto",
  lost: "Siniestrado",
  cancel: "Cancelado",
});
